import { render, staticRenderFns } from "./SetMarketGroupButton.vue?vue&type=template&id=00104fa6&scoped=true"
import script from "./SetMarketGroupButton.vue?vue&type=script&lang=js"
export * from "./SetMarketGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00104fa6",
  null
  
)

export default component.exports